import Swiper, { EffectCreative, Navigation } from "swiper";

document.addEventListener('DOMContentLoaded', () => {
  const articleSliders = document.querySelectorAll('.article__slider')

  if (articleSliders) {
    articleSliders.forEach(slider => {
      const articlePagination = slider.querySelector('.article-thumbs')
      const articleSlider = slider.querySelector('.article-slider')
      const articlePaginations = slider.querySelectorAll('.thumbs__item')
      const nextEl = slider.querySelector('.slider-navigation__button--next')
      const prevEl = slider.querySelector('.slider-navigation__button--prev')
      const articleSlides = articleSlider.querySelectorAll('.article-slider__slide')
      let activeIndex = 0
      const swiper = new Swiper(articleSlider, {
        modules: [Navigation, EffectCreative],
        loop: true,

        effect: "creative",
        speed: 1000,
        parallax: true,
        spaceBetween: 2,
        creativeEffect: {
          prev: {
            translate: ["-20%", 0, -1],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        navigation: {
          nextEl,
          prevEl
        },
        breakpoints: {
          999: {
            allowTouchMove: false,
          },
          0: {
            allowTouchMove: true
          }
        }
      })

      let throttle = false
      let timeout

      const startTimeout = () => {
        clearTimeout(timeout)
        if (throttle) {
          timeout = setTimeout(() => {
            swiper.slideNext()
            throttle = false
          }, 30000)
        } else {
          timeout = setTimeout(() => {
            swiper.slideNext()
          }, 10000)
        }

      }

      nextEl.addEventListener('click', () => throttle = true)
      prevEl.addEventListener('click', () => throttle = true)

      const scrollBlock = () => {
        articlePagination.scrollTo({
          left: articlePaginations[activeIndex].offsetLeft,
          behavior: 'smooth'
        })
      }

      const resize = () => {
        let hasScroll = articlePagination.scrollWidth > articlePagination.parentElement.clientWidth
        hasScroll ? articlePagination.classList.add('article-thumbs--overflow') : articlePagination.classList.remove('article-thumbs--overflow')
      }

      resize()
      window.addEventListener('resize', resize)

      swiper.on('slideChange', () => {
        articlePaginations[activeIndex].classList.remove('thumbs__item--active')
        activeIndex = swiper.realIndex
        const video = articleSlides[activeIndex].querySelector('video')
        if (video) {
          video.pause()
          video.currentTime = 0
        }
        scrollBlock()
        setTimeout(() => {
          if (video) video.play()
          articlePaginations[activeIndex].classList.add('thumbs__item--active')
          startTimeout()
        }, 1000)
      })

      articlePaginations.forEach((pagination, index) => {
        pagination.addEventListener('click', () => {
          throttle = true
          swiper.slideTo(index + 1)
        })
      })

      let animate = false
      const startAnimate = () => {
        animate = true
        articlePaginations[activeIndex].classList.add('thumbs__item--active')
        startTimeout()

      }
      window.addEventListener('scroll', () => {
        if (window.scrollY > slider.offsetTop + slider.clientHeight) return
        if (window.scrollY >= slider.offsetTop) {
          if (animate) return;
          startAnimate()
        }
      })
    })
  }
})